import React from 'react';
import { IFinanceOperatorsItem } from 'entities/financeOperations/types';
import { MoreInfo } from 'shared/ui';
import { AboutWrapper } from 'widgets/promoB2B/ui/PromoB2BDetailStyles';
import { useCacheData } from 'shared/hooks';
import { useAppDispatch } from 'app/store';
import { CityType } from 'shared/types';
import { fromDateToHumanReadableText } from 'shared/helpers/fromDateToHumanReadableText';
import { countCitiesToText, mapTypeOutputToText } from 'widgets/financeOperations/utils';
import { Button } from '@mui/material';
import { UploadFinanceOperationsEditReason } from 'entities/financeOperations';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { useGetCitiesQuery } from 'features/getCities/api/getCitiesApi';
import { useGetCountriesByIdQuery } from 'features/getCountries/api/getCountriesApi';
import { useGetReasonByIdQuery } from 'entities/financeOperations/api';
import { DrawerFinanceOperations } from 'widgets/financeOperations/ui/DrawerFinanceOperations';

type FinanceOperationsDetailInfoProps = {
  data: IFinanceOperatorsItem;
  drawerVariant: string;
  setDrawerVariant: React.Dispatch<React.SetStateAction<string>>;
};
export const FinanceOperationsDetailInfo = ({
  data,
  drawerVariant,
  setDrawerVariant,
}: FinanceOperationsDetailInfoProps) => {
  const country_id = data.country_ids[0];
  const dispatch = useAppDispatch();
  const { data: citiesList } = useGetCitiesQuery({ country_id });
  const { data: countryData } = useGetCountriesByIdQuery({ id: country_id });
  const { data: reasonData } = useGetReasonByIdQuery({ id: data.downtime.reason_id });

  const cachedCities = useCacheData<CityType>(citiesList as CityType[]);

  const handleDrawerClick = () => {
    dispatch(setDrawerOpen(true));
    setDrawerVariant('EditReason');
  };

  const mapCurrencyToHumanText = (currency: string) => {
    switch (currency) {
      case 'kzt': {
        return 'тенге';
      }
      case 'kgs': {
        return 'сом';
      }
      case 'uzs': {
        return 'сум';
      }
    }
  };

  return (
    <>
      <AboutWrapper>
        <div className="infoBlock">
          <MoreInfo>
            <div className="title">Страна</div>
            <div className="content">{countryData?.name || '---'}</div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Комиссия, %</div>
            <div className="content">{data.commission_percent}</div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Города</div>
            <div className="content">
              {countCitiesToText(countryData?.name, data.city_ids, citiesList, cachedCities) || '---'}
            </div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Причина отключения</div>
            <div className="content">{reasonData?.title?.ru || '---'}</div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Дата и время недоступности фин оператора</div>
            <div className="content">{fromDateToHumanReadableText(data.downtime.unavailable_until_at, true)}</div>
          </MoreInfo>
        </div>
        <div className="infoBlock">
          <MoreInfo>
            <div className="title">Минимальная комиссия</div>
            <div className="content">
              {data.commission_min} {mapCurrencyToHumanText(data.withdrawal_service.currency)}
            </div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Подтверждение при выводе средств</div>
            <div className="content">{data.is_needed_validation ? 'Да' : 'Нет'}</div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Активно</div>
            <div className="content">{data.city_ids.length !== 0 ? 'Да' : 'Нет'}</div>
          </MoreInfo>
        </div>
        <div className="infoBlock">
          <MoreInfo>
            <div className="title">Тип вывода</div>
            <div className="content">{mapTypeOutputToText(data.type)}</div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Тип приложения</div>
            <div className="content">{data.app_type ? data.app_type.toUpperCase() : '---'}</div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Лимит на вывод средств</div>
            <div className="content">{data.limit ?? '---'}</div>
          </MoreInfo>
        </div>
      </AboutWrapper>
      <Button
        onClick={handleDrawerClick}
        variant="contained"
      >
        Редактировать причину
      </Button>
      {drawerVariant === 'EditReason' && (
        <DrawerFinanceOperations title="Редактировать причину">
          <UploadFinanceOperationsEditReason data={data} />
        </DrawerFinanceOperations>
      )}
    </>
  );
};
